const normalizeTouchData = (touchData) => {
  const normalizedData = {};
  Object.keys(touchData).forEach((key) => {
    const normalized = parseInt(touchData[key], 0);
    if (Number.isNaN(normalized)) return;
    // @ts-ignore TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    normalizedData[key] = normalized;
  });
  return normalizedData;
};

export default normalizeTouchData;
